import React from 'react';
import BaseContainer from '../../baseContainers/BaseContainer';
import {withTranslation} from 'react-i18next';
import { withRouter } from "react-router-dom";
import {Card} from 'primereact/card';
import DashboardMapComponent from './DashboardMapComponent';
import DashboardService from '../../services/DashboardService';

class DashboardContainer extends BaseContainer {
    constructor(props) {
        super(props, new DashboardService());
        this.state = {
            markers: [],
            projectMarkers: [],
            accommodationMarkers: [],
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchAccomodationMarkers();
        this.fetchProjectMarkers();
    }

    fetchAccomodationMarkers() {
        this.service.getAccommodationMarkers().then((response) => {
            this.setState((prevState) => {
                const newAccommodationMarkers = response.map((el) => {
                    el.icon = 'mdi-bed';
                    el.color = '#ff9900';
                    el.type = "ACCOMMODATION";
                    return el;
                });
                const newMarkers = [...prevState.projectMarkers, ...newAccommodationMarkers];
                return {
                    accommodationMarkers: newAccommodationMarkers,
                    markers: newMarkers,
                };
            });
        }).catch(()=>{
            this.showErrorMessage("Błąd pobrania markerów noclegu")
        });
    }

    fetchProjectMarkers() {
        this.service.getProjectMarkers().then((response) => {
            this.setState((prevState) => {
                const newProjectMarkers = response.map((el) => {
                    el.icon = 'mdi-home-city';
                    el.color = '#274e82';
                    el.type = "PROJECT";
                    return el;
                });
                const newMarkers = [...newProjectMarkers, ...prevState.accommodationMarkers];
                return {
                    projectMarkers: newProjectMarkers,
                    markers: newMarkers,
                };
            });
        }).catch(()=>{
            this.showErrorMessage("Błąd pobrania markerów projektu")
        });
    }

    filterMarkersByTypes = (types) => {
        if (types.length === 0) {
            this.setState({
                markers: [],
            });
        } else {
            const {projectMarkers, accommodationMarkers} = this.state;
            const allMarkers = projectMarkers.concat(accommodationMarkers);
            const filteredMarkers = allMarkers.filter((marker) => types.includes(marker.type));
            this.setState({
                markers: filteredMarkers,
            });
        }
    };

    getRankingCleanSearchCriteria() {
        return {};
    }

    breadCrumbItems() {
        return [];
    }
    render() {
        const {markers} = this.state;
        return (
            <React.Fragment>
                <Card className='m-3'>
                    <DashboardMapComponent
                        markers={markers}
                        onSelectedTypesChange={(types) => {
                            this.filterMarkersByTypes(types);
                        }}
                    />
                </Card>
            </React.Fragment>
        );
    }
}

DashboardContainer.propTypes = {};
export default withRouter(withTranslation()(DashboardContainer));
